import type { WaterGradient } from '../os/waterScene';

/**
 * mcgraw-hill: the desktop water's light gradient, a steel blue around
 * #dce7f0: #b9cde0 to #dfe9f2 in linear light, which the scene's lift toward
 * white settles at about #dde6f0. mcgrawHillTheme.css paints the same
 * gradient before (or without) WebGL.
 */
export const MCGRAW_HILL_LIGHT_WATER_GRADIENT: WaterGradient = [
  [0.485, 0.61, 0.745],
  [0.738, 0.815, 0.888],
];
